export default {
  // Tiêu đề trang
  'adsAgent.title': 'Liên kết quy kết đại lý',

  // Trường tìm kiếm
  'adsAgent.agentNameChoose': 'Chọn đại lý',
  'adsAgent.dateRange': 'Thời gian vận hành',

  // Nút
  'adsAgent.search': 'Tìm kiếm',
  'adsAgent.reset': 'Đặt lại',
  'adsAgent.add': 'Thêm',
  'adsAgent.addAdsAgent': 'Thêm liên kết quy kết đại lý',
  'adsAgent.delete': 'Xóa',
  'adsAgent.save': 'Lưu',
  'adsAgent.cancel': 'Hủy',

  // Cột bảng
  'adsAgent.serial': 'Số thứ tự',
  'adsAgent.agentName': 'Tên đại lý',
  'adsAgent.adsName': 'Tên cấu hình quy kết',
  'adsAgent.adsType': 'Kênh quy kết',
  'adsAgent.operator': 'Người vận hành',
  'adsAgent.operationTime': 'Thời gian vận hành',
  'adsAgent.action': 'Hành động',

  // Nhãn biểu mẫu
  'adsAgent.adsAccount': 'Cấu hình quy kết',

  // Xác thực biểu mẫu
  'adsAgent.agentNameRequired': 'Vui lòng chọn đại lý',
  'adsAgent.adsTypeRequired': 'Vui lòng chọn kênh quy kết',
  'adsAgent.adsAccountRequired': 'Vui lòng chọn cấu hình quy kết',

  // Thông báo
  'adsAgent.addSuccess': 'Thêm thành công',
  'adsAgent.addFailed': 'Thêm thất bại',
  'adsAgent.deleteSuccess': 'Xóa thành công',
  'adsAgent.deleteFailed': 'Xóa thất bại',
  'adsAgent.confirmDelete': 'Bạn có chắc chắn muốn xóa bản ghi này không?',
  'adsAgent.fetchTypesFailed': 'Không thể tải loại nền tảng quy kết',
  'adsAgent.fetchAdsAccountsFailed': 'Không thể tải danh sách cấu hình quy kết',
  'adsAgent.fetchAgentsFailed': 'Không thể tải danh sách đại lý',

  // Phân trang
  'adsAgent.totalRecords': 'Tổng cộng {total} bản ghi',
  'adsAgent.pagination': 'Trang {current} của {page}, Tổng cộng {total} bản ghi',
};
